import { Link } from "react-router-dom";
import { Truck, MapPin, ArrowLeft, Home } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Branded 404 — "Load not found" — playful trucking metaphor while still
 * giving the user two clear routes home (Home + Quote page).
 */
export default function NotFound() {
  return (
    <div className="bg-[var(--lt-bg)] min-h-[calc(100vh-88px)] flex items-center" data-testid="not-found-page">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20 grid grid-cols-1 md:grid-cols-2 gap-12 items-center w-full">
        <div>
          <div className="font-mono-lt text-xs uppercase tracking-[0.3em] text-[var(--lt-accent-bright)] mb-3">
            // Error 404
          </div>
          <h1 className="font-display font-black text-6xl md:text-7xl uppercase text-[color:var(--lt-text)] leading-none">
            Load Not Found.
          </h1>
          <p className="text-slate-600 dark:text-slate-300 mt-4 text-lg max-w-md">
            This route isn&apos;t on today&apos;s dispatch board. Let&apos;s get you back on the road.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link to="/">
              <Button
                data-testid="not-found-home"
                className="bg-[var(--lt-accent)] hover:bg-[var(--lt-accent-hover)] text-white h-12 px-6 rounded-xl font-head uppercase tracking-widest text-xs"
              >
                <Home className="h-4 w-4 mr-2" /> Back Home
              </Button>
            </Link>
            <Link to="/quote">
              <Button
                variant="outline"
                data-testid="not-found-quote"
                className="bg-transparent border-[var(--lt-border)] hover:bg-[var(--lt-panel-hover)] h-12 px-6 rounded-xl font-head uppercase tracking-widest text-xs"
              >
                Request a Quote
              </Button>
            </Link>
          </div>
          <button
            type="button"
            onClick={() => window.history.back()}
            className="mt-6 inline-flex items-center text-sm text-[var(--lt-accent-bright)] hover:underline"
            data-testid="not-found-back"
          >
            <ArrowLeft className="h-4 w-4 mr-1" /> Go back a step
          </button>
        </div>

        <div className="relative">
          <div className="relative aspect-square rounded-3xl overflow-hidden bg-[color:var(--lt-navy)] border border-[var(--lt-border)]">
            <div className="absolute inset-0 flex flex-col items-center justify-center text-white">
              <div className="text-[10rem] font-display font-black leading-none text-white/10 select-none">404</div>
              <Truck className="h-20 w-20 text-white -mt-10" strokeWidth={1.5} aria-hidden="true" />
              <div className="mt-4 inline-flex items-center gap-2 font-mono-lt text-xs uppercase tracking-[0.25em] text-white/70">
                <MapPin className="h-4 w-4" aria-hidden="true" /> Off the highway
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
